import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useNeuroMessages } from './MessageContext';
import NeuroMessage from './NeuroMessage';
import { useQuestionContext } from './QuestionContext';
import Tooltip from './Tooltip';
import { renderQuestionErrors } from './ValidationMessages';
import {usePages, useGuideConfig} from '../hooks';

const QuestionGroupHeader = (props) => {
  const { hasMessage } = useNeuroMessages();
  const { questionGroup, className } = props;
  const componentClass = 'questionGroupHeader';
  const classes = classNames(className, componentClass, 'questionGroup__header');
  const groupKey = questionGroup?.type === 'CardBuilder' && questionGroup?.attributes ? questionGroup.attributes?.questionGroupKey : questionGroup.key;
  const guideConfig = useGuideConfig();
  const hasLabel = hasMessage(questionGroup.key);

  // TODO: Look into refactoring a common error handler to question group header / question header -JJames
  const { validationErrors = [] } = usePages();
  const attributes = questionGroup?.attributes || {};
  const questionContext = useQuestionContext();
  const ErrorTag = guideConfig?.errorValidations?.options?.inlineTag;
  const errorProps =
    attributes?.error?.props ||
    questionContext.questionGroupTypes?.attributes?.error?.props;
  const groupErrors = validationErrors.filter(
    (e) => e.key === groupKey && guideConfig.errorValidations?.options?.inlineCardBuilderError
  );

  // noinspection JSPrimitiveTypeWrapperUsage
  const customTooltipRender = questionContext.renderCustomTooltip(new String(questionGroup.key), null, {className: `${componentClass}__tooltip` });

  const label = (
    <NeuroMessage id={questionGroup.key} shouldHideIfNotFound={true} />
  );
  const subtext = (
    <NeuroMessage
      id={`${questionGroup.key}.subtext`}
      shouldHideIfNotFound={true}
    />
  );

  const tooltip = (
    <NeuroMessage id={`${questionGroup.key}.tooltip`} key={`${questionGroup.key}.tooltip`} shouldHideIfNotFound={true}>
      {() => <Tooltip className={`${componentClass}__tooltip`} messageId={`${questionGroup.key}.tooltip`}/> }
    </NeuroMessage>
  );

  const error = () =>
    ErrorTag ? (
      <ErrorTag
        key={`${groupKey}.error`}
        className="question__error error"
        {...errorProps}
      >
        {renderQuestionErrors(...groupErrors)}
      </ErrorTag>
    ) : (
      <Tooltip
        type="error"
        key={`${questionGroup.key}.error`}
        className="error"
        messageId={questionGroup.key}
        iconRender={<i className="fa fa-exclamation-circle"/>}
        content={<span>{renderQuestionErrors(...groupErrors)}</span>}
        {...errorProps}
      />
    );

  const errorNode =
    groupErrors.length > 0 &&
    groupErrors[0]?.errors &&
    questionContext.displayValidationErrors &&
    (questionContext.questionGroupTypes?.attributes?.error?.node ||
    error());

  return (
    hasLabel && (
      <>
        <h1 className={classes}>
          {label}
          {tooltip}
          {customTooltipRender}
          {subtext && <div className="subtext">{subtext}</div>}
        </h1>
        {errorNode}
      </>
    )
  );
};

QuestionGroupHeader.propTypes = {
  questionGroup: PropTypes.any,
  className: PropTypes.string,
};

export default QuestionGroupHeader;
